import { RootState } from 'src/redux/createRootReducer'

export const selectPostingAvatarFromState = (state: RootState): boolean =>
  state.app.updateProfilePhoto.postingAvatar

export const selectPostingAvatarTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.updateProfilePhoto.postingAvatarTopLevelError
